export default __webpack_public_path__ + "static/media/gallery.72193b23.svg";